import PostsOverview from './PostsOverview';

export default PostsOverview;
